import { useFlag } from '@unleash/proxy-client-react'

export const useFeatureFlag = (flagName: string): boolean => {
	return useFlag(flagName)
}